/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Errors_Resendfailed1Inputs */

const he_auth_signup_errors_resendfailed1 = /** @type {(inputs: Auth_Signup_Errors_Resendfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שליחת אימייל האימות נכשלה`)
};

const en_auth_signup_errors_resendfailed1 = /** @type {(inputs: Auth_Signup_Errors_Resendfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to resend verification email`)
};

/**
* | output |
* | --- |
* | "Failed to resend verification email" |
*
* @param {Auth_Signup_Errors_Resendfailed1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_signup_errors_resendfailed1 = /** @type {((inputs?: Auth_Signup_Errors_Resendfailed1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Errors_Resendfailed1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_errors_resendfailed1(inputs)
	return en_auth_signup_errors_resendfailed1(inputs)
});
export { auth_signup_errors_resendfailed1 as "auth_signup_errors_resendFailed" }